import React from "react";
import styles from "./PresentersProfiles.module.css";
import PresenterCard from "./PresenterCard";
import {motion, AnimatePresence} from "framer-motion";
import {FilteredUserInfo} from "../../models/UserFilter";
import {useSelector} from "react-redux";
import {AppState} from "../../../../root/RootReducer";
import {useEffect} from "react";
import {verticalList} from "../../../../common/homePage/model/HomePage";
import PuiMessage from "../../../../components/widgets/PuiMessage";

interface PresentersProfilesProps {
  anime: boolean;
  users?: FilteredUserInfo[];
  msg?: string;
  professionalName?: string;
  recProList?: verticalList[];
  openMsg: (event: React.MouseEvent, flg: boolean, name: string) => void;
  closeMsg: () => void;
}

function PresentersProfiles(props: PresentersProfilesProps) {
    const {anime, users, msg, professionalName, recProList, openMsg, closeMsg} =
    props;

    const {userFilter} = useSelector((state: AppState) => ({
        userFilter: state.userFilter.UserFilters
    }));

    useEffect(() => {
        console.log(userFilter);
    }, [userFilter]);

    const contents = (
        <>
            {!users && <h3>該当するProfessionalが御座いません。</h3>}

            {users && (
                <div className={styles.grid}>
                    {users.map((user: FilteredUserInfo, index: number) => (
                        <PresenterCard
                            key={index}
                            filteredUserInfo={user}
                            recProList={recProList}
                            link={"videos"}
                            openMsg={openMsg}
                        />
                    ))}
                </div>
            )}
            <PuiMessage
                open={msg === "add"}
                duration={3000}
                type="success"
                title="おすすめPresenterに登録しました。"
                detail={[professionalName]}
                onClose={closeMsg}
            />

            <PuiMessage
                open={msg === "del"}
                duration={3000}
                type="success"
                title="おすすめPresenterから削除しました。"
                detail={[professionalName]}
                onClose={closeMsg}
            />
        </>
    );

    return (
        <AnimatePresence>
            {anime && (
                <motion.div
                    key="professionalIndex"
                    initial={{opacity: 0}}
                    animate={{opacity: 1}}
                    transition={{duration: 1}}
                    exit={{opacity: 0}}
                >
                    {contents}
                </motion.div>
            )}
            {!anime && <div>{contents}</div>}
        </AnimatePresence>
    );
}

export default PresentersProfiles;
